import validate from "/srv/projects/www.cultus-dresden.de/site/node_modules/.pnpm/nuxt@4.5.2_@babel+plugin-syntax-jsx@7.29.7_@babel+core@7.29.7__@babel+plugin-syntax-typ_6385feb2f098e97a5a7aac402008945c/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/srv/projects/www.cultus-dresden.de/site/node_modules/.pnpm/nuxt@4.5.2_@babel+plugin-syntax-jsx@7.29.7_@babel+core@7.29.7__@babel+plugin-syntax-typ_6385feb2f098e97a5a7aac402008945c/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}